import { useColorModeValue } from "@chakra-ui/react"

const usePrimaryColor = () => {
  return useColorModeValue("#3797a6", "#43ffaa")
}

export default usePrimaryColor
